import React from 'react';
import { FiZap } from 'react-icons/fi';

// SiteFlash Logo Component - Modern Design
export const SiteFlashLogo = ({ 
  variant = 'full',  // 'icon', 'full', 'compact'
  size = 'md',       // 'xs', 'sm', 'md', 'lg', 'xl'
  color = 'default', // 'default', 'white', 'dark', 'color'
  showSlogan = false,
  className = ''
}) => {
  
  const sizes = {
    xs: { icon: 'w-4 h-4', text: 'text-sm', slogan: 'text-[10px]', gap: 'gap-1' },
    sm: { icon: 'w-5 h-5', text: 'text-lg', slogan: 'text-xs', gap: 'gap-1.5' },
    md: { icon: 'w-6 h-6', text: 'text-xl', slogan: 'text-xs', gap: 'gap-2' },
    lg: { icon: 'w-8 h-8', text: 'text-2xl', slogan: 'text-sm', gap: 'gap-2' },
    xl: { icon: 'w-10 h-10', text: 'text-3xl', slogan: 'text-base', gap: 'gap-3' }
  };
  
  const colors = {
    default: { icon: 'text-yellow-400', site: 'text-white', flash: 'text-yellow-400', slogan: 'text-slate-400' },
    white: { icon: 'text-white', site: 'text-white', flash: 'text-white', slogan: 'text-white/70' },
    dark: { icon: 'text-yellow-500', site: 'text-slate-900', flash: 'text-yellow-500', slogan: 'text-slate-600' },
    color: { icon: 'text-yellow-400', site: 'text-slate-900', flash: 'text-yellow-500', slogan: 'text-slate-500' }
  };
  
  const s = sizes[size];
  const c = colors[color];
  
  if (variant === 'icon') {
    return (
      <div className={`inline-flex items-center justify-center ${className}`}>
        <FiZap className={`${s.icon} ${c.icon}`} />
      </div>
    );
  }
  
  return (
    <div className={`inline-flex flex-col ${className}`}>
      <div className={`flex items-center ${s.gap}`}>
        <FiZap className={`${s.icon} ${c.icon}`} />
        <span className={`font-bold ${s.text}`}>
          <span className={c.site}>Site</span>
          <span className={c.flash}>FLASH</span>
        </span>
      </div>
      {showSlogan && (
        <span className={`${s.slogan} ${c.slogan} mt-1`}>
          by MSC • Créez votre site en un éclair
        </span>
      )}
    </div>
  );
};

// SiteFlash Badge Component - For footer/powered by
export const SiteFlashBadge = ({ 
  color = 'default',  // 'default', 'muted', 'light'
  size = 'sm',
  className = ''
}) => {
  const sizes = {
    xs: { text: 'text-[10px]', icon: 'w-3 h-3', gap: 'gap-1', padding: 'px-2 py-0.5' },
    sm: { text: 'text-xs', icon: 'w-3.5 h-3.5', gap: 'gap-1', padding: 'px-2.5 py-1' },
    md: { text: 'text-sm', icon: 'w-4 h-4', gap: 'gap-1.5', padding: 'px-3 py-1.5' }
  };
  
  const colors = {
    default: { bg: 'bg-yellow-400/10', border: 'border-yellow-400/20', icon: 'text-yellow-400', text: 'text-slate-300' },
    muted: { bg: 'bg-slate-800', border: 'border-slate-700', icon: 'text-yellow-400', text: 'text-slate-400' },
    light: { bg: 'bg-slate-100', border: 'border-slate-200', icon: 'text-yellow-500', text: 'text-slate-600' }
  };
  
  const s = sizes[size];
  const c = colors[color];
  
  return (
    <div className={`inline-flex items-center ${s.gap} ${s.padding} ${c.bg} border ${c.border} rounded-full ${className}`}>
      <FiZap className={`${s.icon} ${c.icon}`} />
      <span className={`${s.text} ${c.text} font-medium`}>
        Propulsé par <span className="text-yellow-400 font-semibold">SiteFLASH</span>
      </span>
    </div>
  );
};

// Compact version for sidebar
export const SiteFlashCompact = ({ className = '' }) => (
  <div className={`flex items-center gap-2 ${className}`}>
    <div className="w-8 h-8 bg-gradient-to-br from-yellow-400 to-amber-500 rounded-lg flex items-center justify-center shadow-lg shadow-yellow-500/20">
      <FiZap className="w-5 h-5 text-slate-900" />
    </div>
    <div className="flex flex-col">
      <span className="text-sm font-bold leading-tight">
        <span className="text-white">Site</span>
        <span className="text-yellow-400">FLASH</span>
      </span>
      <span className="text-[10px] text-slate-500">by MSC</span>
    </div>
  </div>
);

export default SiteFlashLogo;
